@if (options && options.length) {
  <div class="d-flex admin-search-filter"
    >
    <p-select [options]="options" [(ngModel)]="searchRoute"></p-select>
    <span class="input-icon-wrapper">
      <label class="sr-only" for="adminSearchFilter">Search</label>
      <input type="text" class="full-width admin-search-filter-input" #searchBar (keydown.enter)="navigateWithSearchFilter(searchBar.value.trim())" id="adminSearchFilter">
      <button type="button" class="btn-a11y" (click)="navigateWithSearchFilter(searchBar.value.trim())" aria-label="Search">
        <i class="far fa-search"></i>
      </button>
    </span>
    <!-- <button (click)="navigateWithSearchFilter();">
    Search
  </button> -->
</div>
}
